import type { BrandId } from "@msb/reader-bridge";

const stylesheets: Record<BrandId, () => Promise<unknown>> = {
  mysmartbook: () => import("@msb/design-tokens/css/mysmartbook.css"),
  chatnovel: () => import("@msb/design-tokens/css/chatnovel.css"),
};

// Titre d'onglet par marque ; l'icône MySmartBook est déclarée dans index.html.
const titles: Record<BrandId, string> = {
  mysmartbook: "Reader My Smart Book",
  chatnovel: "Reader ChatNovel",
};

export function loadBrandStyles(brand: BrandId): Promise<unknown> {
  document.documentElement.dataset.brand = brand;
  document.title = titles[brand];
  if (brand !== "mysmartbook") document.querySelector('link[rel="icon"]')?.remove();
  return stylesheets[brand]();
}
